/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DocumentType } from '../../models/document-type';

export interface MarkDummyAsRead$Params {
  documentType: DocumentType;
}

export function markDummyAsRead(http: HttpClient, rootUrl: string, params: MarkDummyAsRead$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, markDummyAsRead.PATH, 'post');
  if (params) {
    rb.path('documentType', params.documentType, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

markDummyAsRead.PATH = '/api/dummies/mark-as-read/{documentType}';
